/*
 * @Description:
 * @Author: fiveonelei
 * @Date: 2022-03-18 22:05:05
 * @FilePath: /vise/packages/app-share/src/composable/use-request-data-method/index.ts
 */


import useRecFeedsMethods from './fetch-rec-feeds';


export default function useRequestDataMethods() {
  const fetchRecFeeds = useRecFeedsMethods();
  return {
    fetchRecFeeds,
  };
};
